export const AVAILABLE_PRODUCT_LINES_LIST_TEST_ID = 'available-product-lines-list';
export const AVAILABLE_PRODUCT_LINES_HINT_TEST_ID = 'available-product-lines-hint';
export const AVAILABLE_PRODUCT_LINES_SKELETON_TEST_ID = 'available-product-lines-skeleton';

export const INITIATE_PROPOSAL_BULLET_TABS_TEST_ID = 'initiate-proposal-bullet-tabs';
export const INITIATE_PROPOSAL_EXPERIENCE_FORM_ID = 'initiate-proposal-experience-form';
export const INITIATE_PROPOSAL_FAVORITE_FORM_ID = 'initiate-proposal-favorite-form';

export const SHELF_QUOTE_RADIO_OPTION_TEST_ID = 'initiate-proposal-shelf-quote-radio-option';
export const CUSTOM_PROPOSAL_RADIO_OPTION_TEST_ID = 'initiate-proposal-custom-proposal-radio-option';
export const RENEWAL_SHELF_QUOTE_RADIO_OPTION_TEST_ID = 'initiate-proposal-renewal-shelf-quote-radio-option';
export const FAVORITE_QUOTE_RADIO_OPTION_TEST_ID = 'initiate-proposal-favorite-quote-radio-option';
export const RENEWAL_CUSTOM_QUOTE_RADIO_OPTION_TEST_ID = 'initiate-proposal-renewal-custom-quote-radio-option';

export const FAVORITE_QUOTE_STEP_TEST_ID = 'initiate-proposal-favorite-quote-step';
export const FAVORITE_PROPOSAL_SUMMARY_TABLE_TEST_ID = 'initiate-proposal-favorite-proposal-summary-table';
